import { ModelValidation } from "@/models/modelvalidation";

export interface IAssignment {
    contentProviderUuid?: string | null;
    aNumber?: string | null;
    note?: string | null;
}

export interface IANumber {
    programContentUuid?: string | null;
    hasProgramContent?: boolean;
    phoneNumber?: string | null;
    note?: string | null;
    fromServer?: boolean;
    aNumbersNoteMaxLength?: number;
    OverrideGlobalCheck?:boolean;
}

export class ANumber extends ModelValidation {
    public phoneNumber!: string | null;
    public programContentUuid!: string | null;
    public hasProgramContent!: boolean;
    public note!: string | null;
    public fromServer!: boolean;
    public aNumbersNoteMaxLength!: number;
    public OverrideGlobalCheck:boolean;

    constructor(aNumber: IANumber) {
        super();

        if (!aNumber) {
            throw new Error("Cannot construct ANumber from falsey IANumber");
        }

        this.phoneNumber = aNumber.phoneNumber || null;
        this.programContentUuid = aNumber.programContentUuid || null;
        this.hasProgramContent = aNumber.hasProgramContent || false;
        this.note = aNumber.note || null;
        this.fromServer = aNumber.fromServer || false;
        this.aNumbersNoteMaxLength = 255;
        this.OverrideGlobalCheck = false;
    }

    public static empty(): ANumber {
        return new ANumber({});
    }

    public toNewANumberDto(): IANumber {
        return {
            phoneNumber: this.phoneNumber!.replace(/\s/g, ""),
            note: this.note,
            OverrideGlobalCheck:this.OverrideGlobalCheck
        };
    }

    public toUpdateANumberDto(): IANumber {
        // these wind up being the same implementation but are semantically different
        return {
            phoneNumber: this.phoneNumber!.replace(/\s/g, ""),
            note: this.note,
            programContentUuid: this.programContentUuid
        };
    }

    public toAssignANumberDto(cpUuid: string | null): IAssignment {
        return {
            aNumber: this.phoneNumber,
            contentProviderUuid: cpUuid,
            note: this.note
        };
    }
}
